import { System, SystemImpl } from 'minecs';
import type { GameModel } from 'yage/game/GameModel';
import { SpatialAudio } from 'yage/schemas/audio/SpatialAudio';
import { AirportState, AirportStation, AirportPlane } from '../components/index.js';
import { ids } from '../services/world.js';
import { PHASE } from '../domain/operations.js';

// The other ambience presets include baked-in voices; keep the mechanical apron bed only.
const STATION_LOOPS = ['', '', '', '', '', '', 'apt-amb-apron', ''];

/** Replicated intent only; the YAGE draw system owns each device's audio graph. */
@System(AirportState)
export class AirportAudioState extends SystemImpl<GameModel> {
  static depth = 4900;
  run = (g: GameModel) => {
    for (const id of ids(g, AirportStation)) {
      const station = g.getTypedUnsafe(AirportStation, id), audio = g.getTypedUnsafe(SpatialAudio, id);
      const activity = Math.min(1, (station.queueLength + station.busy) / 8);
      audio.sound = STATION_LOOPS[station.index];
      audio.enabled = station.unlocked && audio.sound.length > 0;
      audio.volume = 1.3;
      audio.refDistance = 650;
      audio.maxDistance = 6000;
      audio.rolloff = 0.4;
      audio.air = false;
      audio.params = { activity };
    }
    for (const id of ids(g, AirportPlane)) {
      const plane = g.getTypedUnsafe(AirportPlane, id), audio = g.getTypedUnsafe(SpatialAudio, id);
      audio.sound = 'apt-amb-jet-engine';
      audio.enabled = plane.phase !== PHASE.AIRBORNE;
      audio.volume = 0.6;
      audio.refDistance = 800;
      audio.maxDistance = 6000;
      audio.rolloff = 0.5;
      audio.air = false;
      audio.params = { thrust: plane.phase === PHASE.TAXI ? 0.85 : plane.phase === PHASE.APPROACH ? 0.35 : 0.08 };
    }
  };
}
